import React from 'react'
import LogingLogo from '../../images/loging_logo.png'
import { Container, Box, Grid, Card } from '@material-ui/core'
import { BasicLabel } from '../../components/abstractObjects/Label'

export const HelpForm = () => {
    return (<Container maxWidth="md">
        <Box mt="calc(9.5rem - 6%)">
            <Grid>
                <form>
                    <Card className="">
                        <Box p="5px" />
                        <Box mb="1.5rem" px="2rem" align="center" style={{ borderLeft: "5px solid #4db5ff" }}><img style={{ width: "90%" }} src={LogingLogo} alt="logo" /></Box>
                        <Box p="2rem 2rem 1rem 2rem" mb="1rem">
                            <Box pb="0.5rem">
                                <p><BasicLabel text="HELP_LABEL" /></p>
                            </Box>
                        </Box>
                    </Card>
                </form>
            </Grid>
        </Box>
    </Container>);
}

export default HelpForm;